"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var PriceZoneProductPrice_1 = require("../../../product/model/PriceZoneProductPrice");

var PriceZoneProductPriceConverter_1 = require("./PriceZoneProductPriceConverter");

var PriceZoneProductPriceConverterImpl =
/*#__PURE__*/
function (_PriceZoneProductPric) {
  _inherits(PriceZoneProductPriceConverterImpl, _PriceZoneProductPric);

  function PriceZoneProductPriceConverterImpl() {
    _classCallCheck(this, PriceZoneProductPriceConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(PriceZoneProductPriceConverterImpl).apply(this, arguments));
  }

  _createClass(PriceZoneProductPriceConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new PriceZoneProductPrice_1.PriceZoneProductPrice(PriceZoneProductPrice_1.PriceZoneProductPrice.schema.priceZoneId.valueOf(source), PriceZoneProductPrice_1.PriceZoneProductPrice.schema.actualRegularPrice.valueOf(conversions.toBigNumber(source.actualRegularPrice)), PriceZoneProductPrice_1.PriceZoneProductPrice.schema.actualMarginPrice.valueOf(conversions.toBigNumber(source.actualMarginPrice)), PriceZoneProductPrice_1.PriceZoneProductPrice.schema.actualMarginPercentage.valueOf(conversions.toBigNumber(source.actualMarginPercentage)), PriceZoneProductPrice_1.PriceZoneProductPrice.schema.unitPrice.valueOf(conversions.toBigNumber(source.unitPrice)));
    }
  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        priceZoneId: source.priceZoneId,
        actualRegularPrice: conversions.fromBigNumber(source.actualRegularPrice),
        actualMarginPrice: conversions.fromBigNumber(source.actualMarginPrice),
        actualMarginPercentage: conversions.fromBigNumber(source.actualMarginPercentage),
        unitPrice: conversions.fromBigNumber(source.unitPrice)
      });
      return result;
    }
  }]);

  return PriceZoneProductPriceConverterImpl;
}(PriceZoneProductPriceConverter_1.PriceZoneProductPriceConverter);

exports.PriceZoneProductPriceConverterImpl = PriceZoneProductPriceConverterImpl;